export const state = {
  shippings: [],
  systemShipping: [],
  systemShippingfile: [],
  shippingfiles: []
};

export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/shippings/state.js